import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Button, Form } from 'formik-semantic-ui';
import { EUserGroup } from '@relab/alstom-ptw-shared';
import * as Yup from 'yup';

import { UserSelectComponent } from '../UserSelectComponent';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwTestRequestedModalValues {
  user: string;
}

const PtwTestRequestedSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    user: Yup.string().required(t('Required field')).ensure(),
  });

interface PtwTestRequestedModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  projectId: string;
  onSubmit: any;
}

class PPtwTestRequestedModal extends Component<PtwTestRequestedModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;
    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Assign tester'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Assign tester'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ user: null }}
            validationSchema={PtwTestRequestedSchema(t)}
            onSubmit={this.props.onSubmit}
          >
            <UserSelectComponent name="user" projectId={this.props.projectId} group={EUserGroup.COLLAUDATORE} />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwTestRequestedModal = withTranslation()(PPtwTestRequestedModal);
